import React, { useEffect, useState } from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { API_BASE_URL } from "../../ApiConfig";

// The private live streams a poll can be shown in, newest first.
const day = (value) => {
  const d = value ? new Date(value) : null;
  return d && !Number.isNaN(d.getTime())
    ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" })
    : "";
};
const streamLabel = (s) =>
  [s.name || "Live stream", day(s.date), s.broadcaster?.profileName, `(${s.channelname})`].filter(Boolean).join(" · ");

/**
 * Pick the private live stream an admin poll appears in. "" means the poll
 * is kept but shown in no stream. disabled: a host's own poll, which stays
 * in the host's stream.
 */
const StreamPicker = ({ value, onChange, disabled = false }) => {
  const [streams, setStreams] = useState([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/livestream/getallStream`)
      .then((r) => r.json())
      .then((data) => {
        const rows = data?.result?.result || data?.result?.data || [];
        setStreams(
          rows
            .filter((s) => s.type === "private")
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      })
      .catch(() => setFailed(true));
  }, []);

  // Keep the current stream selectable even if it is no longer listed
  const options =
    value && !streams.some((s) => s.channelname === value) ? [{ channelname: value }, ...streams] : streams;

  return (
    <FormControl fullWidth variant="filled" disabled={disabled}>
      <InputLabel id="poll-stream-label" shrink>
        Live stream
      </InputLabel>
      <Select labelId="poll-stream-label" displayEmpty value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <MenuItem value="">
          <em>Not shown in any live stream</em>
        </MenuItem>
        {options.map((s) => (
          <MenuItem key={s.channelname} value={s.channelname}>
            {streamLabel(s)}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {disabled
          ? "This poll was made by the stream's host and stays in that stream."
          : failed
          ? "Could not load the live streams. Try again later."
          : value
          ? "Viewers of this private live stream will see the poll and can vote."
          : "Choose a private live stream to show this poll in."}
      </FormHelperText>
    </FormControl>
  );
};

export default StreamPicker;
